import { render } from "./NoOrders.vue?vue&type=template&id=2a64370e"
import script from "./NoOrders.vue?vue&type=script&lang=js"
export * from "./NoOrders.vue?vue&type=script&lang=js"

import "./NoOrders.vue?vue&type=style&index=0&id=2a64370e&lang=css"
script.render = render

export default script